import defaultAuthor from "@/constants/defaultAuthor";
import TimeAgo from "@/component/TimeAgo";
import siteInfo from "@/constants/siteInfo";


import SVG from "react-inlinesvg";

 
const FirstCard = ({ content, isLCP = false, categoryTitle = "" }) => {
    return (
        <div className="flex flex-col overflow-hidden">
            <div className="flex-shrink-0">
                <div className="relative z-0">
                    <a
                        href={content?.canonical_url ?? ""}
                        onClick={() => {
                            let eventName = `Home Screen - ${categoryTitle}`;
                            sendGAEvent({
                                eventName: eventName,
                                pageTitle: document?.title,
                                pageLocation: window?.location?.href,
                            });
                        }}
                    >
                        <img
                            className="w-full rounded-md"
                            src={`${content?.image_small}?size=360:203`}
                            srcSet={`${content?.image_small}?size=360:203 1x`}
                            title={content?.image_title}
                            alt={content?.image_title ? content?.image_title : siteInfo?.siteName}
                            fetchPriority={isLCP ? "high" : "auto"}
                            loading={isLCP ? "eager" : "lazy"}
                            role="button"
                            width="360" // Fixed width
                            height={Math.floor((9 / 16) * 360)} // Maintain 16:9 aspect ratio for height
                        />

                    </a>

                     {content?.content_type === "video" && (
                        <div className="absolute inset-0 flex justify-center items-center">
                <SVG
                  className="w-10 h-10"
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/play-media.svg"
                />
              </div>
                    )}
                </div>
            </div>

            <div className="py-2">
                <a
                    href={content?.canonical_url ?? ""}

                >
                    <h3
                        className="text-lg font-bold line-clamp-3 hover:text-primary"
                        dangerouslySetInnerHTML={{
                            __html: `${content?.title_short || content?.title}`,
                        }}
                    />
                </a>
                <p className="text-xs text-gray-500 font-extralight mt-1 mb:text-sm xs:text-sm">
                    <img
                        loading="lazy"
                        className="h-[16px] w-[16px] inline-block mr-1"
                        alt="read video icon"
                        height={16}
                        width={16}
                        src={
                            content?.content_type === "video"
                                ? "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/prod/watchType.svg"
                                : "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/prod/readType.svg"
                        }
                    />
                    <time dateTime={content?.datetime_published}>
                        <TimeAgo dateTime={content?.datetime_published} />
                    </time>{" "}
                    · By{" "}
                    <a
                        href={
                            content?.author?.[0]?.canonical_url ?? defaultAuthor.canonical_url
                        }
                    >
                        <span className="text-primary">
                            {content?.author[0]?.title ?? defaultAuthor.title}
                        </span>
                    </a>
                </p>
            </div>
        </div>
    );
};

const StandardCard = ({ content, categoryTitle = "" }) => {
    return (
        <div className="flex rounded-sm overflow-hidden">
            <div>
                <div className="relative z-0">
                    <a
                        onClick={() => {
                            let eventName = `Home Screen - ${categoryTitle}`;
                            sendGAEvent({
                                eventName: eventName,
                                pageTitle: document?.title,
                                pageLocation: window?.location?.href,
                            });
                        }}
                        href={content?.canonical_url ?? ""}
                    >
                        <img
                            className="js-lazy-image object-fill rounded-md"
                            src={`https://akm-img-a-in.tosshub.com/lingo/uptak/resources/breaking-news-04-default-imahe.png?size=320:180&q=25`}
                            data-src={`${content?.image_small}?size=320:180`}
                            title={content?.image_title}
                            alt={
                                content?.image_title ? content?.image_title : siteInfo?.siteName
                            }
                            loading={"lazy"}
                            role="button"
                            height="180"
                            width="150"
                        />
                    </a>

                    {content?.content_type === "video" && (
                        <div className="absolute inset-0 flex justify-center items-center">
                <SVG
                  className="w-10 h-10"
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/play-media.svg"
                />
              </div>
                    )}
                </div>
            </div>
            <div className="px-2 flex-1">
                <a
                    href={content?.canonical_url ?? ""}
                    onClick={() => {
                        let eventName = `Home Screen - ${categoryTitle}`;
                        sendGAEvent({
                            eventName: eventName,
                            pageTitle: document?.title,
                            pageLocation: window?.location?.href,
                        });
                    }}
                >
                    <h3
                        className="text-md font-bold hover:text-primary line-clamp-3"
                        dangerouslySetInnerHTML={{
                            __html: `${content?.title_short || content?.title}`,
                        }}
                    />
                </a>
                <p className="text-xs text-gray-500 font-extralight mt-1 line-clamp-2 mb:text-sm xs:text-sm">
                    <img
                        loading="lazy"
                        className="h-[16px] w-[16px] inline-block mr-1"
                        height={16}
                        width={16}
                        alt="read video icon"
                        src={
                            content?.content_type === "video"
                                ? "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/prod/watchType.svg"
                                : "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/prod/readType.svg"
                        }
                    />
                    <time dateTime={content?.datetime_published}>
                        <TimeAgo dateTime={content?.datetime_published} />
                    </time>{" "}
                    · By{" "}
                    <a
                        href={
                            content?.author[0]?.canonical_url ?? defaultAuthor.canonical_url
                        }
                    >
                        <span className="text-primary">
                            {content?.author[0]?.title ?? defaultAuthor.title}
                        </span>
                    </a>
                </p>
            </div>
        </div>
    );
};

const NewsGrid = ({
    newsData = null,
    isLCP = false,
    showHeader = true,
    isGold = true,
    isAutoLiveBlog = false,
}) => {
    // const size = useWindowSize();
    const cardsArray = newsData?.content && newsData?.content?.slice(0, 6) || [];
    return (
        <div className="my-2 py-2">
            {showHeader && (
                <div className="flex my-2 items-center justify-between">
                    <div className="text-primary flex font-bold text-lg sm:text-xl xs:text-xl md:text-xl">
                        <span className="w-2 h-[auto] mr-1 inline-block bg-primary"></span>
                        <h2 >
                            {newsData?.info?.name ||
                                (isGold ? "Gold Related" : "Silver Related") + " News"}
                        </h2>
                    </div>
                    <div>
                        <a
                            href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/${isGold ? "gold-rates" : "silver-rates"}`}
                            className="text-sm text-gray-500 ml-auto"
                        >
                            और देखें
                            <SVG
                                className="w-5 h-5 inline ml-2"
                                src="https://akm-img-a-in.tosshub.com/lingo/uptak/resources/prod/rightArrowRound.svg"
                            />
                        </a>
                    </div>
                </div>
            )}

            <div className="flex flex-col md:flex-row gap-2 md:max-h-[26rem]">
                <div className="w-full md:w-1/2">
                    {cardsArray[0] && (
                        <>
                            <FirstCard
                                content={cardsArray[0]}
                                isLCP={isLCP}
                                categoryTitle={newsData?.info?.name ?? "न्यूज़"}
                            />

                        </>
                    )}
                    {cardsArray[1] && (
                        <div className="my-2">
                            <StandardCard
                                content={cardsArray[1]}
                                categoryTitle={newsData?.info?.name ?? "न्यूज़"}
                            />

                        </div>
                    )}
                </div>

                <div
                    className="w-full md:w-1/2 md:overflow-auto"
                    style={{ height: "fit-content" }}
                >
                    {cardsArray?.slice(2)?.map((content, index) => (
                        <div
                            key={index}
                            className={`mb-2 ${isAutoLiveBlog && index > 3 ? "hidden" : ""}`}
                        >
                            <StandardCard
                                content={content}
                                categoryTitle={newsData?.info?.name ?? "न्यूज़"}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NewsGrid;
